<template>
    <ul
        class="SocialLinks"
        :class="classes"
    >
        <li
            v-for="item in items"
            :key="item.id"
        >
            <a
                :href="item.providerLink"
                class="gtm-click-social"
                :data-category="item.providerName"
                target="_blank"
            >
                <BaseIcon
                    :icon="item.providerName"
                    :color="color"
                />
            </a>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'SocialLinks',
    props: {
        items: {
            type: Array,
            default: null
        },
        color: {
            type: String,
            default: "#0C5987"
        },
        classes: {
            type: String,
            default: null
        }
    },
    methods: {
        visitUrl(url) {
            window.open(url)
        }
    }
}
</script>
<style lang="scss" scoped>
    ul {
        display: flex;
        align-items: center;
        margin: 0 -0.5rem;

        li {
            margin: 0 0.5rem;
            cursor: pointer;
        }
    }
</style>
